import {
  PageBlueprint,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import apiDocsPlugin from '@backstage/plugin-api-docs/alpha';

/**
 * Keep native api-docs cards/config/external routes, but disable its page and
 * the auto-registered entity content tabs.
 *
 * - page:api-docs: the app owns /api-docs via apiDocsPageModule, which now
 *   renders the unified catalog page with the API kind preselected.
 * - entity-content:api-docs/definition: auto-registered "Definition" tab at path
 *   /definition for API entities. Replaced by our apiDefinitionEntityContent at
 *   path / (root), which is the canonical URL.
 * - entity-content:api-docs/apis: auto-registered "APIs" tab for all component
 *   entities. Not in old EntityPage; service components use componentApiEntityContent.
 */
const apiDocsFeature = apiDocsPlugin.withOverrides({
  extensions: [
    apiDocsPlugin.getExtension('page:api-docs').override({
      disabled: true,
    }),
    apiDocsPlugin.getExtension('entity-content:api-docs/definition').override({
      disabled: true,
    }),
    apiDocsPlugin.getExtension('entity-content:api-docs/apis').override({
      disabled: true,
    }),
  ],
});

const apiDocsPage = PageBlueprint.make({
  name: 'api-docs',
  params: {
    path: '/api-docs',
    noHeader: true,
    loader: () =>
      import('../components/catalog/CustomCatalogPage').then(m => (
        // The standalone API explorer defaulted to the "all" scope; without
        // this the picker would fall back to "owned" and hide APIs the
        // current user does not own.
        <m.CustomCatalogPage
          initialKind="api"
          initialUserFilter="all"
          isLegacyEntryPoint
        />
      )),
  },
});

export const apiDocsPageModule = createFrontendModule({
  pluginId: 'app',
  extensions: [apiDocsPage],
});

export default apiDocsFeature;
